/* singles */

import ResourceDetail from './resource-detail/script';

export default {
	[ResourceDetail.selector]: ResourceDetail
};
